module.exports = __webpack_public_path__ + "/build/web/images/hero-training@2x.a5e95bd600b2ffdc4debd09f7906a996.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-training@2x.jpg
// module id = 152
// module chunks = 13